<template>
    <div class="body">
      <div class="header">
        <el-form :model="SelectPieceworkProcessDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="工序名称">
              <el-input
                v-model="SelectPieceworkProcessDTO.productionProcesses"
                placeholder="工序名称"
              ></el-input>
            </el-form-item>
   
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <br>
          <el-form-item>
            <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增工序"
        :visible.sync="drawer"
        class="order-dialog"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >

 
    <el-form-item  label="工序名称" prop="name">
          <el-input
            class="input-remark"
            v-model="accountForm.productionProcesses"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
 
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item  label="面积" prop="price">
          <el-input
            class="input-remark"
            v-model="accountForm.area"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-form-item >
            <el-button
              
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog title="编辑工序" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false"     class="order-dialog">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <el-form-item  label="工序名称" prop="name">
          <el-input
            class="input-remark"
            
            v-model="accountForm.productionProcesses"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item  label="单价" prop="price">
          <el-input
            class="input-remark"
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item  label="面积" prop="price">
          <el-input
            class="input-remark"
            v-model="accountForm.area"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-button  @click="dialogVisible = false">取 消</el-button>
          <el-button  type="primary" @click="editAccount()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>
      <el-dialog title="计件详情" :visible.sync="visible"  width="60%" :close-on-click-modal="false">
        <el-form
          ref="searchForm"
          :model="searchForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <el-button  class="btn-style btn-cancel" type="primary" @click="updatePieceworkProcess">新增</el-button>
        <el-button  class="btn-style btn-delete"  type="danger" @click="DeletePieceworkCount">删除</el-button>
        <div style="text-align: center;">
          </div>
          
        <el-table
                        v-if="pieceworkCount && pieceworkCount.length"
                        :data="pieceworkCount"
                        stripe
                        border
                        style="width: 100%"
                        class="pieceworkCount"
                        @selection-change="handleSelectionChange1"
                        :cell-style="styleBack"
                    >
                    <el-table-column
                    type="selection"
                    align="center"
                    width="55"
                  ></el-table-column>
                    <el-table-column
                            prop="createTime"
                            align="center"
                            label="时间"
                        ></el-table-column>
                    <el-table-column
                            prop="category"
                            align="center"
                            label="产品种类"
                        ></el-table-column>
                        <el-table-column
                            prop="productionProcesses"
                            align="center"
                            label="工序名称"
                        ></el-table-column>
                        <el-table-column
                            prop="area"
                            align="center"
                            label="工作量"
                        ></el-table-column>
                        <el-table-column
                            prop="operator"
                            align="center"
                            label="操作员"
                        ></el-table-column>
                        <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEditPieceworkCount(row)">编辑 | </el-link>
          </template>
        </el-table-column>
        </el-table>
          <el-button  @click="visible = false">取 消</el-button>
        </el-form>
      </el-dialog>
      <el-dialog title="新增工作量" :visible.sync="dialogVisible1"  width="25%" :close-on-click-modal="false"     class="order-dialog">
        <el-form
          ref="searchForm"
          :model="searchForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <el-form-item  label="剩余 :" prop="name">
          <span class="table-label"
          > {{searchForm.remainingArea?searchForm.remainingArea:'--'}}</span>
        </el-form-item>
        <el-form-item  label="操作员" prop="price">
          <el-input
            class="input-remark"
            v-model="searchForm.operator"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item  label="工作量" prop="price">
          <el-input
            class="input-remark"
            v-model="searchForm.workload"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
          <el-button  @click="dialogVisible1 = false">取 消</el-button>
          <el-button  type="primary" @click="toUpdatePieceworkProcess()">
            确 定
          </el-button>
        </el-form>
      </el-dialog>
      
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
          ></el-table-column>
          <el-table-column
            prop="productionProcesses"
            align="center"
            label="工序名称"
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="单价"
          ></el-table-column>
          <el-table-column
            prop="area"
            align="center"
            label="面积"
          ></el-table-column>
          <el-table-column
            prop="remainingArea"
            align="center"
            label="剩余"
          ></el-table-column>
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">编辑 | </el-link>
            <el-link type="success"  @click="handleEditInfo(row)"> 计件详情</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
  
 
    </div>
  </template>
  
  <script>
  import { selectPieceworkProcess,bathDeletePieceworkProcess,addPieceworkProcess,upPieceworkProcess,selectPieceworkCount,updatePieceworkProcess,bathDeletePieceworkCount} from '@/api/order/reckon.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        multipleSelection1:[],
        ids: '',
        dialogVisible1:false,
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        SelectPieceworkProcessDTO:{
          access:'',
            startTime: '',
            endTime: '',
            orderId: '',
            productionProcesses:''
        },
        category:[],
        drawer: false,
        dialogVisible:false,
        visible:false,
        accountForm:{
          id:'',
          access:'',
          category:'',
          orderId:'',
          productionProcesses:'',
          price:'',
          area:'',
          remainingArea:""
        },
        searchForm: {
          id:'',
          access: '',
          category: '',
          orderId: '',
          productionProcesses: '',
          price:'',
          area:'',
          remainingArea:'',
          workload:'',
          operator:'',
          createTime:''
        },
        pieceworkCount:[],
        DeleteDTO:{
          id:'',
          status:''
        },
        SelectPieceworkCountInfoDTO:{
            orderId:'',
            productionProcesses:''
        },
        rules:{
        //   name:[
        //             { required: true, message: '请输入工序名称', trigger: 'blur' }]
           
            }

      }
    },
    
  
    mounted() {
      this.SelectPieceworkProcessDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.SelectPieceworkProcessDTO.orderId = this.$route.query.orderId ? this.$route.query.orderId : ""
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.accountForm.orderId=this.$route.query.orderId ? this.$route.query.orderId : ""
        this.accountForm.category= this.$route.query.category ? this.$route.query.category : ""
        this.drawer = true
      },
      handleEditPieceworkCount(row){
        this.accountForm.access=localStorage.getItem("access")
        this.accountForm.orderId=row.orderId 
        this.accountForm.category= row.category
        console.log(this.accountForm)
        console.log(row)
        this.dialogVisible1 = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      handleEditInfo(row){
        console.log(this.searchForm)
        this.searchForm.id=row.id
        this.searchForm.access=row.access
        this.searchForm.category=row.category
        this.searchForm.orderId=row.orderId
        this.searchForm.productionProcesses=row.productionProcesses
        this.searchForm.price=row.price
        this.searchForm.area=row.area
        this.searchForm.remainingArea=row.remainingArea
        this.SelectPieceworkCountInfoDTO.orderId=row.orderId
        this.SelectPieceworkCountInfoDTO.productionProcesses=row.productionProcesses
        selectPieceworkCount(this.SelectPieceworkCountInfoDTO).then((res) => {
         this.pieceworkCount = res.data.data
        })
        this.visible=true
      },
 
      getTableData() {
        selectPieceworkProcess(this.currentPage, this.pageSize, this.SelectPieceworkProcessDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addPieceworkProcess(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },

      toUpdatePieceworkProcess(){
            updatePieceworkProcess(this.searchForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
            this.dialogVisible1=false
            selectPieceworkCount(this.SelectPieceworkCountInfoDTO).then((res) => {
         this.pieceworkCount = res.data.data
        })
        this.getTableData()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
      },
   //修改
   editAccount() {
    upPieceworkProcess(this.accountForm).then((res) => {
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeletePieceworkProcess(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     //删除计件详情
    DeletePieceworkCount(){

      if(this.multipleSelection1.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeletePieceworkCount(this.multipleSelection1).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
              selectPieceworkCount(this.SelectPieceworkCountInfoDTO).then((res) => {
         this.pieceworkCount = res.data.data
        })
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //弹窗勾选
      handleSelectionChange1(val){
        this.multipleSelection1 = val;
      },
      updatePieceworkProcess(){
      this.dialogVisible1=true
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.SelectPieceworkProcessDTO.startTime = e[0]
          this.SelectPieceworkProcessDTO.endTime = e[1]
        } else if (!e) {
          this.SelectPieceworkProcessDTO.startTime = ''
          this.SelectPieceworkProcessDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
        getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    return _this.gettime;
    }
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}


  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  

  </style>
  